import { render } from "./RecoverPasswordEmail.vue?vue&type=template&id=082f15e0"
import script from "./RecoverPasswordEmail.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__